import { HTMLAttributes, ReactNode } from 'react';
import { StoryblokEditable } from '@activebrands/core-web/libs/storyblok/storyblok';
import { styled } from '@activebrands/core-web/libs/styletron';
import { StyletronStyle } from '@activebrands/core-web/types/styletron';
import { TextStyleKey } from 'config/branding/textStyles';
import responsiveTextStyles from '@activebrands/core-web/utils/responsive-text-styles';
import { Styles } from '@activebrands/core-web/utils/style-object-to-props';

const StyledHeading = styled('h2');

interface HeadingProps extends HTMLAttributes<HTMLHeadingElement> {
    $style?: StyletronStyle;
    as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | string;
    children?: ReactNode;
    fontKeys?: TextStyleKey | (TextStyleKey | null)[];
    sbEditable?: StoryblokEditable;
}

const Heading = ({
    $style = {},
    as = 'h2',
    children,
    fontKeys = 'Primary/60_100_-3',
    sbEditable,
    ...rest
}: HeadingProps) => {
    const fontStyle = responsiveTextStyles(fontKeys as Styles);
    const style = { ...fontStyle, ...$style };

    return (
        <StyledHeading $as={as} $style={style} {...sbEditable} {...rest}>
            {children}
        </StyledHeading>
    );
};

export default Heading;
